import TextareaAutosize, { type TextareaAutosizeProps } from 'react-textarea-autosize';
import InputLabel from './InputLabel';
import { type TooltipProps } from './Tooltip';
import InputError from './InputError';
import React from 'react';
import { Field } from '~/components/ui/field';
import { cn } from '~/lib/utils';

type TTextareaAutoSizeProps = TextareaAutosizeProps & React.RefAttributes<HTMLTextAreaElement>;
type TextAreaProps = {
  label?: React.ReactNode;
  placeholder?: string;
  className?: string;
  readOnly?: boolean;
  textareaProps?: Omit<TTextareaAutoSizeProps, 'value' | 'onChange'>;
  tooltip?: React.ReactNode;
  tooltipProps?: Partial<TooltipProps>;
  disabled?: boolean;
  error?: string;
} & Pick<TTextareaAutoSizeProps, 'value' | 'onChange' | 'readOnly'>;

export default function Textarea(props: TextAreaProps) {
  return (
    <Field
      className={cn('font-medium', props.className)}
      data-disabled={props.disabled ? true : undefined}
    >
      {props.label ? (
        <InputLabel label={props.label} tooltip={props.tooltip} tooltipProps={props.tooltipProps} />
      ) : null}
      <TextareaAutosize
        disabled={props.disabled}
        minRows={3}
        maxRows={7}
        {...props.textareaProps}
        readOnly={props.readOnly}
        className={cn(
          'border-input bg-background ring-offset-background placeholder:text-muted-foreground min-h-[4.5rem] w-full rounded-md border px-3 py-2 text-sm font-normal shadow-xs',
          'focus-visible:ring-ring/50 focus-visible:outline-hidden focus-visible:ring-[3px]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          props.textareaProps?.className,
        )}
        value={props.value}
        onChange={props.onChange}
      />
      {props.error ? <InputError error={props.error} /> : null}
    </Field>
  );
}
